// returns true if the given value is a thenable object
export function thenable(o) {
    return o !== undefined && o !== null && typeof o.then === 'function';
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/utils/promise/thenable.js
// module id = 249
// module chunks = 25